import { IAttribute, IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.oracleCloudStorage.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.OracleCloudStorage),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.OracleCloudStorage)
    ]
})
export class OracleCloudStorageLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly ACCESS_KEY_ID: IAttribute;
    public static readonly ACCESS_KEY: IAttribute;
    public static readonly SERVICE_URL: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessKeyID,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'ACCESS_KEY_ID',
        accepts: ['String'],
        templatable: true
    })
    public accessKeyId?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AmazonAccessKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'ACCESS_KEY',
        templatable: true,
        accepts: ['String']
    })
    public secretAccessKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServiceUrl,
        association: 'SERVICE_URL',
        templatable: true
    })
    public serviceUrl?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
